"use client"

import Script from "next/script"
import { CookieCategory } from "@/lib/cookies"
import { useCookies } from "@/lib/context/cookie-context"

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

/**
 * Google tag (gtag.js) for Google Ads. Loads only when marketing cookie consent is granted
 * (same policy as Meta Pixel).
 *
 * Deploy env: set `NEXT_PUBLIC_GOOGLE_ADS_ID` to the `AW-…` ID (e.g. trgovina B2C:
 * AW-18086873321; horeca B2B: set a different value on that deployment).
 */
export function GoogleTag() {
  const { hasConsent } = useCookies()
  const googleAdsId = process.env.NEXT_PUBLIC_GOOGLE_ADS_ID?.trim()
  const marketingAllowed = hasConsent(CookieCategory.MARKETING)

  if (!googleAdsId || !marketingAllowed) {
    return null
  }

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(googleAdsId)}`}
        strategy="afterInteractive"
      />
      <Script id="google-tag-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', ${JSON.stringify(googleAdsId)});
        `}
      </Script>
    </>
  )
}
